import React from 'react'

import ImpressionsBudgetSection from '../../../../../Multiplatform/UploadAdCreative/ImpressionsBudgetSection'
import FrequencyCapFields from '../../formFields/FrequencyCapFields'
import CampaignObjectiveFields from '../formFields/CampaignObjectiveFields'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

const NewCampaignImpressionsFields = ({ formik, remainingImpressions }) => {
  const drawerFormClasses = useDrawerFormStyles()

  if (remainingImpressions < 1) {
    return <ErrorMessage fontSize={14} error="Your remaining impressions are too low to create a campaign." />
  }

  return (
    <div className={drawerFormClasses.subSection}>
      <CampaignObjectiveFields formik={formik} />
      <ImpressionsBudgetSection remainingImpressions={remainingImpressions} showPacing={true} formik={formik} />

      <div className={drawerFormClasses.subSection}>
        <FrequencyCapFields formik={formik} />
      </div>
    </div>
  )
}

export default NewCampaignImpressionsFields
